import React from 'react';
import { IFormProps } from './Form.types';
import { FormWrapper } from './Form.styles';

export const Form: React.FC<IFormProps> = ({ onSubmit, testID = 'form', children, role = 'form', className }) => (
  <FormWrapper role={role} data-testid={testID} onSubmit={onSubmit} className={className} no-validate>
    {children}
  </FormWrapper>
);
